import React from 'react';
import BrandLoader from '../../components/BrandLoader';

const CustomLoader = () => <BrandLoader />;

export default CustomLoader;
